













import { defineComponent, computed } from "@vue/composition-api";

export default defineComponent({
  name: "ScoreCard",
  props: {
    entry: {
      type: Number,
      default: 0
    },
    pv: {
      type: Number,
      default: 0
    }
  },
  setup(props) {
    const totalEntry = computed(() => props.entry.toLocaleString());
    const totalPv = computed(() => props.pv.toLocaleString());

    return {
      totalEntry,
      totalPv
    };
  }
});
